"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.sendEmbedApiV1MessageToParent = sendEmbedApiV1MessageToParent;
exports.triggerInteractionsReport = triggerInteractionsReport;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _getQueryParams = _interopRequireDefault(require("./getQueryParams"));
/**
 * A collection of util functions having to do with messaging parent frame via postMessage().
 */

///////////////////////////////////////////////////////////
// Import dependencies
///////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////
// Private helper functions
///////////////////////////////////////////////////////////

/**
 * @returns {string} The embed ID passed via query param, or default value 'ekoembed'
 */
function getEmbedId() {
  return (0, _getQueryParams["default"])().embedid || 'ekoembed';
}

/**
 * @returns {string} The Walmart Category Page ID (if exists)
 */
function getWcpId() {
  return (0, _getQueryParams["default"])().wcp || '';
}
function doPostMessage(msg) {
  window.parent.postMessage(msg, '*');
}
function getPageViewId() {
  return typeof window !== 'undefined' && typeof window.EkoAnalytics === 'function' && window.EkoAnalytics('getPageViewId') || '';
}

///////////////////////////////////////////////////////////
// Exported API
///////////////////////////////////////////////////////////

/**
 * Send a message to parent frame (if exists).
 * @param {string} type - The message type.
 * @param {object} [options] - Optional options object.
 * Must be JSON-serializable.
 * Will be sent in its entirety as the "params" property of the message.
 * @param {any[]} [options.args] - An optional array of serializable arguments.
 * If not provided, will be set to a single item array that contains the "options" object.
 */
function sendEmbedApiV1MessageToParent(type) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var msg = {
    params: options,
    args: options.args || [options],
    embedApiVersion: '1.0',
    embedId: getEmbedId(),
    pageViewId: getPageViewId(),
    // Backwards compatibility
    origin: 'eko',
    embedapi: '1.0',
    wcp: getWcpId()
  };

  // Post twice for backwards compatibility (with and w/o "eko." prefix)
  doPostMessage((0, _objectSpread2["default"])({
    type: type
  }, msg));
  doPostMessage((0, _objectSpread2["default"])({
    type: "eko.".concat(type)
  }, msg));
}

/**
 * Notify parent frame that an `interactions.report` event has occurred.
 * @export
 * @param {string} id - The element ID of the element that was interacted with
 * @param {object} data - Any additional arbitrary data
 */
function triggerInteractionsReport() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  sendEmbedApiV1MessageToParent('interactions.report', (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, data), {}, {
    args: [id, data]
  }));
}
var _default = exports["default"] = {
  sendEmbedApiV1MessageToParent: sendEmbedApiV1MessageToParent,
  triggerInteractionsReport: triggerInteractionsReport
};